import { Button } from './button.js';

export interface ConfirmBarProps {
  /** Pass translated strings. */
  backLabel: string;
  confirmLabel: string;
  onBack: () => void;
  onConfirm: () => void;
  disabled?: boolean;
  /** Shown left of the buttons only while disabled. Pass a translated string. */
  disabledReason?: string;
  backTestId?: string;
  confirmTestId?: string;
  disabledReasonTestId?: string;
}

/**
 * Generic back/confirm action row for multi-step wizards, with an optional
 * inline hint explaining why the confirm action is disabled.
 */
export function ConfirmBar({
  backLabel,
  confirmLabel,
  onBack,
  onConfirm,
  disabled,
  disabledReason,
  backTestId,
  confirmTestId,
  disabledReasonTestId,
}: ConfirmBarProps) {
  return (
    <div className="flex items-center justify-end gap-3 pt-2">
      {disabled && disabledReason !== undefined ? (
        <span
          className="text-xs text-muted-foreground italic mr-auto"
          data-testid={disabledReasonTestId}
        >
          {disabledReason}
        </span>
      ) : null}
      <Button type="button" variant="outline" onClick={onBack} data-testid={backTestId}>
        {backLabel}
      </Button>
      <Button type="button" disabled={disabled} onClick={onConfirm} data-testid={confirmTestId}>
        {confirmLabel}
      </Button>
    </div>
  );
}
